/* Moon Island - mise en page et mouvement (accueil, pages de contenu, collections, fiches produits) */
(function () {
  var root = document.documentElement;
  var main = document.getElementById('main-content');

  /* 0. Fiche produit : onglet Description organisé en sections, titre du bloc similaire (indépendant des animations) */
  if (main && document.body.classList.contains('template-product')) {
    Array.prototype.forEach.call(main.querySelectorAll('[class^="ai-premium-product-related-title"]'), function (t) {
      var rel = (window.miI18n && window.miI18n.related) || '';
      if (rel && t.textContent.replace(/\s+/g, ' ').trim() !== rel) t.textContent = rel;
    });
    Array.prototype.forEach.call(main.querySelectorAll('[class^="ai-premium-product-accordion-content-inner"]'), function (inner) {
      if (inner.hasAttribute('data-mi-sections') || !inner.querySelector('h4')) return;
      inner.setAttribute('data-mi-sections', '');
      var kids = Array.prototype.slice.call(inner.children);
      var current = null;
      kids.forEach(function (node) {
        if (node.tagName === 'H4') {
          current = document.createElement('div');
          current.className = 'mi-sec';
          inner.insertBefore(current, node);
        }
        if (current) current.appendChild(node);
      });
    });
    var fit = function () {
      Array.prototype.forEach.call(main.querySelectorAll('[class^="ai-premium-product-accordion-item"].active [data-accordion-content]'), function (c) {
        c.style.maxHeight = c.scrollHeight + 'px';
      });
    };
    fit();
    window.addEventListener('load', fit);
    window.addEventListener('resize', fit, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  if (!root.classList.contains('mi-js')) return;
  if (!main) { root.classList.add('mi-ready'); return; }

  /* 1. Titres découpés mot à mot (le texte reste lisible tel quel) */
  var headingSel = '.mi-tiles__title,.mi-tm__title,.mi-cards__title,.mi-band__title,.mi-cta__title,[class^="ai-premium-product-related-title"]';
  Array.prototype.forEach.call(main.querySelectorAll(headingSel), function (h) {
    if (h.hasAttribute('data-mi-split')) return;
    var text = h.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;
    h.setAttribute('data-mi-split', '');
    h.setAttribute('aria-label', text);
    h.textContent = '';
    text.split(' ').forEach(function (word, i, all) {
      var outer = document.createElement('span');
      outer.className = 'mw';
      outer.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('span');
      inner.className = 'mwi';
      inner.style.setProperty('--i', i);
      inner.textContent = word;
      outer.appendChild(inner);
      h.appendChild(outer);
      if (i < all.length - 1) h.appendChild(document.createTextNode(' '));
    });
  });

  /* 2. Éléments à révéler au défilement */
  var targets = [];
  function register(el, type) {
    if (el.hasAttribute('data-mi')) return;
    el.setAttribute('data-mi', type);
    targets.push(el);
  }
  function mark(selector, type) {
    Array.prototype.forEach.call(main.querySelectorAll(selector), function (el, i) {
      register(el, type);
      var sibs = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : i;
      el.style.setProperty('--k', Math.max(0, sibs));
      if (type === 'group') {
        Array.prototype.forEach.call(el.children, function (child, k) { child.style.setProperty('--g', k); });
      }
    });
  }
  mark('.mi-tiles__head,.mi-cards__head,.mi-tm__text,.mi-band__txt,.mi-cta__in', 'group');
  mark('.mi-tile', 'tile');
  mark('.mi-card', 'card');
  mark('.mi-tm__media,.mi-band__img', 'wipe');
  mark('[class^="ai-premium-product-related-title"]', 'head');

  /* Cartes produits (collections) et blocs de la fiche produit : apparition colonne par colonne */
  function markRise(selector, getEl) {
    var list = main.querySelectorAll(selector);
    Array.prototype.forEach.call(list, function (node, i) {
      var el = getEl ? getEl(node) : node;
      if (!el || el.hasAttribute('data-mi')) return;
      var cols = 1;
      try {
        var gridEl = el.parentNode;
        var tpl = window.getComputedStyle(gridEl).gridTemplateColumns;
        if (tpl && tpl !== 'none') cols = tpl.split(' ').length;
      } catch (e) {}
      var idx = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : i;
      el.style.setProperty('--c', Math.min(idx % Math.max(cols, 1), 4));
      register(el, 'rise');
    });
  }
  markRise('.product-card', function (card) { return card.parentNode && card.parentNode.classList.contains('grid-item') ? card.parentNode : card; });
  markRise('[class^="ai-premium-product-related-grid"] > *');
  markRise('[class^="ai-premium-product-accordion-item"]');

  /* Les photos « wipe » sont masquées par clip-path avant leur apparition : sur certains navigateurs
     (Chrome Android notamment) l'observateur ne les voit alors jamais. On observe donc leur conteneur,
     qui n'est pas masqué, et on révèle la photo à sa place. */
  function observed(el) {
    return el.getAttribute('data-mi') === 'wipe' && el.parentNode && el.parentNode.nodeType === 1 ? el.parentNode : el;
  }
  var pending = targets.slice();
  function reveal(el) {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-in');
  }

  if (!('IntersectionObserver' in window)) {
    targets.forEach(reveal);
  } else {
    var owners = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        owners.forEach(function (o) { if (o.node === e.target) reveal(o.el); });
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (el) {
      var node = observed(el);
      owners.push({ node: node, el: el });
      io.observe(node);
    });

    /* Sécurité : tout élément qui entre dans l'écran est affiché, quoi qu'il arrive */
    var checking = false;
    function check() {
      checking = false;
      var vh = window.innerHeight || 800;
      pending = pending.filter(function (el) {
        if (el.classList.contains('is-in')) return false;
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.94) { reveal(el); return false; }
        return true;
      });
    }
    function requestCheck() {
      if (!checking && pending.length) { checking = true; window.requestAnimationFrame(check); }
    }
    window.addEventListener('scroll', requestCheck, { passive: true });
    window.addEventListener('resize', requestCheck, { passive: true });
    window.addEventListener('load', requestCheck);
    setTimeout(requestCheck, 1200);
    setTimeout(requestCheck, 4000);
  }

  /* 3. Léger parallaxe sur les grandes photos */
  var imgs = main.querySelectorAll('.mi-tm__media img,.mi-band__img img');
  var visible = [];
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight || 800;
    visible.forEach(function (img) {
      var r = img.parentNode.getBoundingClientRect();
      var p = (vh - r.top) / (vh + r.height);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      img.style.setProperty('--p', p.toFixed(3));
    });
  }
  function request() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }
  if ('IntersectionObserver' in window && imgs.length) {
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var img = e.target.querySelector('img');
        var idx = visible.indexOf(img);
        if (e.isIntersecting && idx === -1) visible.push(img);
        if (!e.isIntersecting && idx !== -1) visible.splice(idx, 1);
      });
      request();
    }, { rootMargin: '10% 0px 10% 0px' });
    Array.prototype.forEach.call(imgs, function (img) { pio.observe(img.parentNode); });
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
  }

  root.classList.add('mi-ready');
})();
